import React from 'react';
import { BaseEdge, getSmoothStepPath } from 'reactflow';

/**
 * Custom edge: solid baseline (BaseEdge) + dashed animated overlay on the same path.
 * Two paths are intentional: the solid line keeps the edge visible; the dashed path
 * runs the flowAnimation (FlowGlobalStyles) to show direction. A single-path version
 * would need custom marker rendering and would lose the solid underlay.
 */
function DraggableEdge({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  markerMid,
  selected,
}) {
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 20,
  });

  const strokeWidth = style.strokeWidth || 2;
  const lineStrokeWidth = selected ? 3 : strokeWidth;
  const baseEdgeStrokeWidth = 2;

  return (
    <>
      <BaseEdge
        path={edgePath}
        markerEnd={markerEnd}
        markerMid={markerMid}
        style={{
          ...style,
          strokeWidth: baseEdgeStrokeWidth,
        }}
      />
      <path
        d={edgePath}
        fill="none"
        stroke={style.stroke || '#a855f7'}
        strokeWidth={lineStrokeWidth}
        strokeDasharray="6 6"
        strokeLinecap="round"
        style={{
          willChange: 'stroke-dashoffset',
          transform: 'translateZ(0)',
          animation: 'flowAnimation 2.5s linear infinite',
        }}
      />
    </>
  );
}

export default DraggableEdge;
